import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import { WalletAllowedListItem, WalletItem, WalletResponse } from './types'

export const allWalletMounted = createEvent()

export const walletAllowedListMounted = createEvent()

export const getWallet = fx<void, WalletResponse>({
  method: 'GET',
  url: `/finance/wallet`,
})

export const getWalletAllowedList = fx<void, any>({
  method: 'GET',
  url: `/finance/wallet_allowed_list`,
})

export const $wallet = restore<WalletItem[]>(
  getWallet.doneData.map((a) => a.body.items),
  [],
)

export const $walletAllowedList = restore<WalletAllowedListItem[]>(
  getWalletAllowedList.doneData.map((a) => a.body.items),
  [],
)

sample({
  clock: allWalletMounted,
  fn: () => ({}),
  target: getWallet,
})

sample({
  clock: walletAllowedListMounted,
  fn: () => ({}),
  target: getWalletAllowedList,
})
